import React, { Component } from "react"

export class MessageNotFound extends Component {
  render() {
    return (
      <p className="is-size-3">The artist you have supplied could not be found.</p>
    )
  }
}
